<template>
  <div>
    <!-- App Bar estilo iPhone -->
    <v-app-bar
      flat
      app
      height="56"
      class="cr-ios-navbar cr-ios-navbar--roomy"
      style="border-bottom: 2px solid var(--capi-orange);"
    >
      <!-- Botón izquierdo (ejemplo: Home) -->
      <v-btn icon class="cr-ios-btn-icon" @click="$router.push('/dashboard')" aria-label="Inicio">
        <i class="fas fa-home"></i>
      </v-btn>

      <!-- Centro: Título iOS + subtítulo (usuario) -->
      <div class="cr-ios-center">
        <div class="cr-ios-title">CapiRunners</div>
        <div class="cr-ios-sub">{{ usuario.username }}</div>
      </div>

      <v-spacer></v-spacer>

      <!-- Menú hamburguesa a la derecha, estilo pill -->
      <v-btn icon class="cr-ios-btn-icon" @click="nav = !nav" aria-label="Menú">
        <i class="fas fa-bars"></i>
      </v-btn>
    </v-app-bar>

    <!-- Drawer estilo iOS -->
    <v-navigation-drawer
      v-model="nav"
      fixed
      app
      left
      width="320"
      class="cr-ios-drawer"
    >
      <v-img
        width="160"
        class="cr-ios-logo"
        src="@/assets/logob.png"
      ></v-img>

      <v-list dense shaped class="cr-ios-list">
        <v-list-item
          to="/dashboard"
          color="#FF6B00"
          active-class="hash"
          class="cr-ios-list-item"
        >
          <v-list-item-title class="cr-ios-item-title">
            Dashboard
          </v-list-item-title>
        </v-list-item>

        <v-list-group
          color="#FF6B00"
          append-icon="fas fa-sort-down"
          v-for="item in menu"
          :key="item.title"
          no-action
          active-class="hash"
          class="cr-ios-list-group"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="cr-ios-section-title" v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in item.items"
            :key="child.title"
            :to="child.link"
            class="cr-ios-list-item"
          >
            <v-list-item-content>
              <v-list-item-title class="cr-ios-item-title" v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- Botón salir anclado abajo, estilo iOS ghost -->
      <div class="salir-container">
        <v-btn
          block
          class="cr-ios-btn-ghost"
          @click="signOut"
        >
          Salir
        </v-btn>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data(){
    return {
      nav:true,
      selectedItem:1,
      menu: [
        {
          items: [{ title: 'Mis Atletas', link: '/atletas' }],
          title: 'Atletas',
        },
        {
          items: [
            { title: 'Pagos de Atletas', link: '/pagos-de-atletas' },
            { title: 'Reporte de Pagos', link: '/reporte-de-pagos' },
            { title: 'Egresos', link: '/egresos' },
          ],
          title: 'Finanzas',
        }
      ],
    }
  },
  methods:{
    ...mapActions(['signOut']),
  },
  computed:{
    ...mapState(['usuario'])
  },
}
</script>

<style>
/* ====== iOS + CapiRunners UI ====== */
:root{
  --capi-orange:#FF6B00;
  --capi-bg:#F7F7F8;
  --capi-card:#FFFFFF;
  --capi-border:rgba(0,0,0,.08);
  --capi-muted:#6B7078;
  --capi-radius:16px;
  --capi-blur:16px;
  --capi-shadow:0 10px 24px rgba(0,0,0,.08);
}

/* Barra translúcida tipo iOS */
.cr-ios-navbar{
  background: rgba(255,255,255,.75)!important;
  backdrop-filter: blur(var(--capi-blur));
  -webkit-backdrop-filter: blur(var(--capi-blur));
  box-shadow: none !important;
}

/* Versión espaciosa */
.cr-ios-navbar--roomy .v-toolbar__content{
  min-height: 56px !important;
  padding: 8px 12px !important;
}

/* Botones tipo pill */
.cr-ios-btn-icon{
  background: #fff !important;
  border: 1px solid var(--capi-border) !important;
  border-radius: 12px !important;
  box-shadow: var(--capi-shadow);
  width: 40px; height: 40px;
  display: flex; align-items: center; justify-content: center;
  transition: transform .12s ease;
}
.cr-ios-btn-icon:active{ transform: scale(.96); }

/* Centro (título y subtítulo) */
.cr-ios-center{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.1;
  pointer-events: none;
}
.cr-ios-title{
  font-size: 18px;
  font-weight: 800;
  color: #1C1C1E;
}
.cr-ios-sub{
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: var(--capi-muted);
}

/* Drawer */
.cr-ios-drawer{
  background: rgba(255,255,255,.8) !important;
  backdrop-filter: blur(var(--capi-blur));
  -webkit-backdrop-filter: blur(var(--capi-blur));
  border-left: 1px solid var(--capi-border);
}
.cr-ios-logo{
  margin: 16px auto 8px !important;
  display: block;
}
.cr-ios-list{
  background: transparent !important;
}
.cr-ios-section-title{
  font-weight: 800 !important;
  color: #1C1C1E;
}
.cr-ios-list-item{
  border-radius: 12px;
  margin: 2px 8px;
}
.cr-ios-item-title{
  font-weight: 600;
  color: #1C1C1E;
}

/* Indicador activo naranja */
.hash{
  border-left: 5px solid var(--capi-orange) !important;
  background: rgba(255,107,0,.06) !important;
  border-radius: 12px;
}

/* Botón Salir estilo iOS ghost */
.cr-ios-btn-ghost{
  height: 44px;
  font-weight: 700;
  border-radius: 14px !important;
  background: #fff !important;
  color: var(--capi-orange) !important;
  border: 1px solid var(--capi-orange) !important;
  box-shadow: none !important;
  text-transform: none !important;
}

/* Contenedor fijo inferior */
.salir-container{
  position: absolute;
  left: 0; right: 0; bottom: 16px;
  padding: 0 16px;
}

/* Fondo general */
.v-application{ background: var(--capi-bg) !important; }
</style>
